// ======================================================================
// 📁 File: src/modules/ppe/pages/planning/components/OrderItemPlanningTable.jsx
// ======================================================================

import React from "react";

export default function OrderItemPlanningTable({ data, onPlan }) {
  return (
    <table className="table table-bordered mb-0">
      <thead className="table-light">
        <tr>
          <th>Order No</th>
          <th>Item</th>
          <th>Product</th>
          <th style={{ width: 80, textAlign: "right" }}>Qty</th>
          <th>Priority</th>
          <th style={{ width: 120 }}>Due Date</th>
          <th>Status</th>
          <th style={{ width: 70, textAlign: "center" }}>Risk</th>
          <th style={{ width: 110 }}>Action</th>
        </tr>
      </thead>

      <tbody>
        {data.length === 0 && (
          <tr>
            <td colSpan={9} className="text-center text-muted">
              No order items found
            </td>
          </tr>
        )}

        {data.map((row) => (
          <tr key={row.id}>
            <td>{row.orderNo}</td>
            <td>{row.itemCode}</td>
            <td>{row.product}</td>
            <td style={{ textAlign: "right" }}>{row.qty}</td>
            <td>{row.priority}</td>
            <td>{row.dueDate}</td>
            <td>{row.planStatus}</td>
            <td style={{ textAlign: "center" }}>
              {row.risk ? "⚠️" : "✔️"}
            </td>
            <td>
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => {
                  console.log(
                    "🟢 PLAN CLICKED – EMITTING TO PARENT",
                    row
                  );
                  onPlan(row);
                }}
              >
                Plan
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
